import React from 'react';
import emptyStateLogo from "@assets/icons/empty-state.svg";
import './EmptyState.scss';
import { Text } from '@mantine/core';

interface IEmptyStateProps {
    message: string;
    variant: string;
}

const sizeMap: Record<string, string> = {
    h5: 'xl',
    body2: 'sm',
};

const EmptyState: React.FC<IEmptyStateProps> = ({ message, variant }) => (
    <div className={`empty-state`}>
        <img src={emptyStateLogo} alt="empty-state" />
        <Text size={sizeMap[variant] || 'md'} mb="xs">
            {message}
        </Text>
    </div>
);

export default EmptyState;
